/* custom.js — Terra Luna India */

/* Collection sidebar filter toggle (jQuery) */
$(document).ready(function(){
  $(document).on('click','.collection-sidebar__group--1.new-category-filter-main button',function(e){
    e.preventDefault();
    $(this).toggleClass('SlideOpenWp');
    $(this).siblings('.new-category-main-collections').slideToggle();
  });
});

/* COLOR SWATCH — gallery update on radio change */
document.addEventListener('DOMContentLoaded', function () {
  initSwatchGallery();
});

function initSwatchGallery() {
  document.querySelectorAll('input.variant__input--color-swatch').forEach(function(radio) {
    if (radio.dataset.rrGalleryBound) return;
    radio.dataset.rrGalleryBound = '1';
    radio.addEventListener('change', function() {
      if (!this.checked) return;
      var colorValue = this.value;
      var fieldset = this.closest('fieldset');
      if (fieldset) {
        fieldset.querySelectorAll('label.color-swatch').forEach(function(l) { l.classList.remove('is-selected'); });
        var lbl = fieldset.querySelector('label[for="' + radio.id + '"]');
        if (lbl) lbl.classList.add('is-selected');
      }
      if (typeof window.rrUpdateGallery === 'function') {
        window.rrUpdateGallery(colorValue);
      }
    });
  });
}

/* ============================================================
   PRICE FORMAT — Convert "Rs. 2 399/-" → "₹2,399"
   Runs on page load and after any DOM mutations (AJAX filters)
   ============================================================ */
(function () {
  'use strict';

  function reformatPrice(raw) {
    if (!raw) return raw;
    var str = raw.trim();
    if (str.charAt(0) === '₹') return str;
    var digits = str.replace(/Rs\.?/gi, '').replace(/[\s\/-]/g, '').replace(/,/g, '').trim();
    var num = parseInt(digits, 10);
    if (isNaN(num)) return raw;
    return '₹' + num.toLocaleString('en-IN');
  }

  function reformatAllMoneySpans() {
    document.querySelectorAll('span.money').forEach(function (el) {
      var current = el.textContent;
      if (current.indexOf('Rs') !== -1) {
        el.textContent = reformatPrice(current);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reformatAllMoneySpans);
  } else {
    reformatAllMoneySpans();
  }

  document.addEventListener('shopify:section:load', reformatAllMoneySpans);

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      var needsReformat = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) needsReformat = true;
        });
        if (m.type === 'characterData' && m.target.textContent.indexOf('Rs') !== -1) {
          needsReformat = true;
        }
      });
      if (needsReformat) {
        clearTimeout(window._rrPriceTimer);
        window._rrPriceTimer = setTimeout(reformatAllMoneySpans, 80);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  window.rrReformatPrices = reformatAllMoneySpans;

})();

/* ============================================================
   SHOPFLO BUY NOW — handleFloBuyNowBtn
   ============================================================ */
function handleFloBuyNowBtn(event) {
  event.preventDefault();
  event.stopPropagation();

  var btn = event.currentTarget || event.target;
  var form = btn.closest('form') || document.querySelector('form[action="/cart/add"]');
  var variantId = null;

  if (form) {
    var sel = form.querySelector('select[data-product-select], select[name="id"]');
    if (sel) variantId = parseInt(sel.value, 10);
    if (!variantId) {
      var radio = form.querySelector('input[name="id"]:checked');
      if (radio) variantId = parseInt(radio.value, 10);
    }
    if (!variantId) {
      var hidden = form.querySelector('input[name="id"]');
      if (hidden) variantId = parseInt(hidden.value, 10);
    }
  }

  if (!variantId) {
    console.warn('[TL] handleFloBuyNowBtn: could not determine variant ID');
    return;
  }

  if (window.flo && typeof window.flo.checkout === 'function') {
    window.flo.checkout({ variantId: variantId, quantity: 1 });
    return;
  }

  if (window.Shopflo && typeof window.Shopflo.checkout === 'function') {
    window.Shopflo.checkout({ variantId: variantId, quantity: 1 });
    return;
  }

  btn.textContent = 'Please wait...';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    var floCheckout = 'https://checkout.shopflo.com/co/checkout?shop=terralunaindia.myshopify.com';
    if (window.flo && typeof window.flo.checkout === 'function') {
      window.flo.checkout({ variantId: variantId, quantity: 1 });
    } else if (window.Shopflo && typeof window.Shopflo.checkout === 'function') {
      window.Shopflo.checkout({ variantId: variantId, quantity: 1 });
    } else {
      window.location.href = floCheckout;
    }
  })
  .catch(function(err) {
    console.error('[TL] Buy Now cart add failed:', err);
    btn.textContent = 'BUY IT NOW';
    btn.disabled = false;
  });
}

/* ============================================================
   OOS SIZE FIX — Disable size buttons that have no available
   variant for the currently selected color on PDP.
   Runs on: page load + every variant:change event.
   Only touches the 'disabled' attribute and 'disabled' class
   on size radio inputs — nothing else is modified.
   ============================================================ */
(function () {
  'use strict';

  function getVariants() {
    var el = document.querySelector('[data-variant-json]');
    if (!el) return [];
    try { return JSON.parse(el.value || el.textContent || '[]'); }
    catch (e) { return []; }
  }

  function getSelectedColor() {
    var checked = document.querySelector('input[data-variant-input][data-color-name]:checked');
    return checked ? checked.value : null;
  }

  function updateSizeAvailability() {
    var variants = getVariants();
    if (!variants.length) return;

    var selectedColor = getSelectedColor();

    // Find all size radio inputs (not color swatches)
    var sizeInputs = document.querySelectorAll('input[data-variant-input]:not([data-color-name])');
    if (!sizeInputs.length) return;

    sizeInputs.forEach(function (input) {
      var sizeValue = input.value;

      // Check if any variant with this size (and selected color if applicable) is available
      var isAvailable = variants.some(function (v) {
        var sizeMatch = v.option1 === sizeValue || v.option2 === sizeValue || v.option3 === sizeValue;
        if (!sizeMatch) return false;
        if (selectedColor) {
          var colorMatch = v.option1 === selectedColor || v.option2 === selectedColor || v.option3 === selectedColor;
          if (!colorMatch) return false;
        }
        return v.available === true;
      });

      var label = document.querySelector('label[for="' + input.id + '"]');

      if (isAvailable) {
        input.removeAttribute('disabled');
        input.classList.remove('disabled');
        if (label) label.classList.remove('disabled');
      } else {
        input.setAttribute('disabled', 'disabled');
        input.classList.add('disabled');
        if (label) label.classList.add('disabled');
      }
    });

    // Also disable Add to Cart button if selected variant is OOS
    var addToCartBtn = document.querySelector('[data-add-to-cart]');
    if (addToCartBtn) {
      var select = document.querySelector('select[data-product-select]');
      if (select) {
        var selectedVariantId = parseInt(select.value, 10);
        var selectedVariant = variants.find(function(v) { return v.id === selectedVariantId; });
        if (selectedVariant && !selectedVariant.available) {
          addToCartBtn.setAttribute('disabled', 'disabled');
          var textEl = addToCartBtn.querySelector('[data-add-to-cart-text]');
          if (textEl) textEl.textContent = 'Sold Out';
        }
      }
    }
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateSizeAvailability);
  } else {
    updateSizeAvailability();
  }

  // Re-run whenever variant changes (color or size selection)
  document.addEventListener('variant:change', function () {
    setTimeout(updateSizeAvailability, 50);
  });

  // Re-run on any radio change (catches color swatch clicks before variant:change fires)
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('input[data-variant-input]')) {
      setTimeout(updateSizeAvailability, 50);
    }
  });

})();
